/*----------------------------------
- TLD APPLICATIONS GATEWAY CONTRACT
----------------------------------*/

/**
 * @docs docs/features/tld-applications
 * @adr  ADR-0065
 */

import type { TldApplicationsQuery } from '@uniquedomains/components/contracts/tlds/public';

/** One page of `/tld/applications`, read live (no cache: Reveal Day shows the import at once). */
export const TLD_APPLICATIONS_GATEWAY_PATH = '/api/website/tld/list-applications';

/** A path page (the SSR route) or the board's query (the board, after mount). */
export type TldApplicationsGatewayRequest = { page: number } | { query: TldApplicationsQuery };
